export interface SearchableOrder {
  id: string;
  legacyId: string;
  name: string;
  customerName: string;
  shippingProvince: string;
  orderNote: string;
  memo: string;
  csOrderStatus: string;
  shopifyFulfillmentStatus: string;
  salesSource: string;
  deliveryMethod: string;
  arrivalContact: string;
  requestedDeliveryDate: string;
  wearingDate: string;
  isExpress: boolean;
  repairFinish?: string;
  repairAtelier?: string;
  repairRequestDate?: string;
  repairInstockDate?: string;
  items: Array<{
    sku: string;
    title: string;
    properties: Array<{ name: string; value: string }>;
  }>;
}

export function normalizeSearchText(value: string): string {
  return value
    .normalize("NFKC")
    .toLocaleLowerCase("ja-JP")
    .replace(/\s+/gu, " ")
    .trim();
}

export function matchesOrderSearch(order: SearchableOrder, query: string): boolean {
  const terms = normalizeSearchText(query).split(" ").filter(Boolean);
  if (terms.length === 0) return true;

  const searchableText = normalizeSearchText([
    order.name,
    order.customerName,
    order.shippingProvince,
    order.orderNote,
    order.memo,
    order.csOrderStatus,
    order.shopifyFulfillmentStatus,
    order.salesSource,
    order.deliveryMethod,
    order.arrivalContact,
    order.requestedDeliveryDate,
    order.wearingDate,
    order.repairFinish ?? "",
    order.repairAtelier ?? "",
    order.repairRequestDate ?? "",
    order.repairInstockDate ?? "",
    order.isExpress ? "特急" : "",
    order.id,
    order.legacyId,
    ...order.items.map((item) => [
      item.sku,
      item.title,
      ...item.properties.map((property) => property.name + " " + property.value),
    ].join(" ")),
  ].join(" "));

  return terms.every((term) => searchableText.includes(term));
}
